import { Component, OnInit } from '@angular/core';
import { UsuarioService } from '../../services/service.index';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: []
})
export class HeaderComponent implements OnInit {
  usuarioNombre: string;
  usuarioApellido: string;

  constructor(public usuarioService: UsuarioService) { }

  ngOnInit() {
    if (localStorage.getItem('usuario')) {
      this.usuarioNombre = 'Ingresos'; //localStorage.getItem('usuario').split(',')[5].split(':')[1].replace('"', '').replace('"', '');
      this.usuarioApellido = 'Nobis'; //localStorage.getItem('usuario').split(',')[6].split(':')[1].replace('"', '').replace('"', '');
    }
  }

}
